import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from "lodash";
import ImportButton from "./ImportButton";

export default class UpdatedLabels extends Component {

	constructor(prop) {
		super(prop);

		this.state = {
			selectedUpdatedLabels: [],
			defaultLanguage: ""
		};
	}

	static propTypes = {
		status: PropTypes.object,
		data: PropTypes.object,
		selectedProject: PropTypes.object,
	};

	selectAllUpdated = (event) => {
		var updatedLabels = [];
		if (event.target.checked)
		{
			_.map(this.props.data.project.codeScan.updatedLabels, (updatedLabel) => {
				updatedLabels.push(updatedLabel.scannedLabel.identifier)
			})
		}
		this.setState({
			selectedUpdatedLabels: updatedLabels
		})
	};



	updateUpdatedSelection = (event) => {
		var selectedLabelsCopy = this.state.selectedUpdatedLabels
		if (event.target.checked)
		{
			selectedLabelsCopy.push(event.target.id)
		}else {
			selectedLabelsCopy.splice(selectedLabelsCopy.indexOf(event.target.id), 1)
		}
		this.setState({
			selectedUpdatedLabels: selectedLabelsCopy
		})
	}

	render() {
		const {status, data} = this.props;

		return (
			<div className="tab-pane" id="profile" role="tabpanel" aria-expanded="false">
				<table className="table">
					<thead className="">
					<tr>
						<th>
							<div className="form-check xpull-left">
								<label className="form-check-label">
									<input type="checkbox" id="updated" value=""
										   onChange={this.selectAllUpdated}/>
									<span className="form-check-sign"/>
								</label>
							</div>

						</th>
						<th>
							Collection
						</th>
						<th>
							id
						</th>
						<th>
							new default
						</th>
						<th>
							current default
						</th>
						<th>
							new allowPlural
						</th>
						<th>
							current allowPlural
						</th>
						<th>
							File:Line
						</th>
					</tr>
					</thead>
					<tbody>
					{_.map(data.project.codeScan.updatedLabels, (updatedLabel, key) => {
						return (
							<tr key={key}>
								<td>
									<div className="form-check xpull-left">
										<label className="form-check-label">
											<input type="checkbox" id={updatedLabel.scannedLabel.identifier}
												   checked={this.state.selectedUpdatedLabels.includes(updatedLabel.scannedLabel.identifier)}
												   onChange={this.updateUpdatedSelection}/>
											<span className="form-check-sign"/>
										</label>
									</div>

								</td>
								<td>
									<small
										title={updatedLabel.scannedLabel.scannedLabelCollection.identifier}>{updatedLabel.scannedLabel.scannedLabelCollection.identifier.split(':').splice(-1)}</small>
								</td>
								<td>{updatedLabel.scannedLabel.name}</td>
								<td>{updatedLabel.scannedLabel.defaultValue}</td>
								<td>{updatedLabel.label.defaultValue}</td>
								<td>{updatedLabel.scannedLabel.allowPlurals.toString()}</td>
								<td>{updatedLabel.label.allowPlurals.toString()}</td>
								<td>
									<small><a
										className="btn btn-link"
										href={"https://" + data.project.git.split(".git")[0].replace(":", "/") + "/tree/" + data.project.sourceBranch + "/" + updatedLabel.scannedLabel.importLocations[0].filePath + "#L" + updatedLabel.scannedLabel.importLocations[0].lineNumber}
										target="_blank">{updatedLabel.scannedLabel.name}:{updatedLabel.scannedLabel.importLocations[0].lineNumber}</a></small>
								</td>
							</tr>
						)
					})}
					</tbody>
				</table>
				<div>
					<ImportButton
						text={"Import updated labels"}
						data={data}
						isDisabled={status.project.codeScan.isRunning}
						labelsToImport={this.state.selectedUpdatedLabels}
						isScannedLabels={true}
						selectedProject={this.props.selectedProject}
						afterImportCallback={() => {this.setState({selectedUpdatedLabels : []})}}
					/>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./React/src/components/CodeScanner/UpdatedLabels.js